<template>
	<div class="home_box" style="background: #f6f6f6;">
		<!-- 首页轮播图 -->
		<div class="home_top_swiper">
			<el-carousel trigger="click" height="100%" :interval="3000" class="el-car">
				<el-carousel-item v-for="(item, index) in bannerData" :key="index">
					<img :src="UPLODE_URL+item.bannerImage" alt="" class="img" />
				</el-carousel-item>
			</el-carousel>

			<div class="uservol">
				<div class="ustit-a">AI智能模拟填报</div>
				<div class="ustit-b" v-if="!token||!user.score">当前为虚拟内容,快来看看适合您的院校吧</div>
				<div class="ustit-b" style="font-weight: normal;" v-else>
					{{user.cityName?user.cityName+'/':''}}{{user.score/100}}/{{user.scorePtn}} · {{user.subjectOnes}} 
					
					<span @click="allUserClick" class="el-icon-edit-outline" style="color: #F34240;"></span>
				</div>
				<!-- <svg class="dashboard" viewBox="0 0 100 100">
				  <defs>
				   <linearGradient id="gradient" gradientUnits="userSpaceOnUse" x1="50" y1="0" x2="50" y2="100%">
				          <stop offset="0%" style="stop-color: rgba(111, 232, 191, 1)" />
				          <stop offset="33%" style="stop-color: rgba(255, 175, 19, 1)" />
				          <stop offset="70%" style="stop-color: rgba(222, 19, 80, 1)" />
				          <stop offset="100%" style="stop-color: rgba(133, 14, 205, 1)" />
				        </linearGradient>
				  </defs>
				<circle class="circle-background" cx="50" cy="50" r="40"></circle>
				<circle class="circle-progress" cx="50" cy="50" r="40"></circle>
				</svg> -->
				<!-- <div class="percentage" id="percentage">0%</div> -->
				<div class="ustit-c" @click="goIndex('2',9)">
					<div class="ustit-cmain">
						<div class="ustit-czu" v-if="!token||(user&&!user.score)">2986 <span>组</span></div>
						<div class="ustit-czu" v-else>{{volNumData.countOne+volNumData.countTwo+volNumData.countThree}} <span>组</span></div>
						<div class="ustit-czu"><span>查看可填报志愿</span></div>
					</div>
				</div>
				<div class="ustit-d">
					<div class="ustit-dli" v-if="token&&user.score"><span>冲击</span>{{volNumData.countOne}}</div>
					<div class="ustit-dli" v-else><span>冲击</span>356</div>
					
					<div class="ustit-dli" v-if="token&&user.score"><span>稳妥</span>{{volNumData.countTwo}}</div>
					<div class="ustit-dli" v-else><span>稳妥</span>1168</div>
					
					<div class="ustit-dli" v-if="token&&user.score"><span>保底</span>{{volNumData.countThree}}</div>
					<div class="ustit-dli" v-else><span>保底</span>1468</div>
					
				<!-- countOne -->
				</div>
				
				<div class="ustit-btn" @click="goIndex('2',9)">智能模拟填报</div>
				
			</div>
		</div>
		
		
		
		<!-- 客服 -->
		<!-- <div class="session">
			<el-popover
			  placement="right"
			  width="170"
			  trigger="hover">
				<img :src="UPLODE_URL+'17433899831931149.jpg'" alt="" style="width: 170px;height: 170px;"/>
				<div style="text-align: center;color: #F75950;">扫描添加老师咨询</div>
			  <div slot="reference"><img style="cursor: pointer" :src="UPLODE_URL+'17355438543421729.png'" alt="" /></div>
			</el-popover>
		</div> -->
		
		
			<div class="home_conav">
				<div class="navli" @click="goIndex('1',1)">
					<img src="../../assets/img/n1.png" alt="" />
					<p>找大学</p>
				</div>
				<div class="navli"  @click="goIndex('1',2)">
					<img src="../../assets/img/n2.png" alt="" />
					<p>查专业</p>
				</div>
				<div class="navli" @click="goIndex('1',3)">
					<img src="../../assets/img/n3.png" alt="" />
					<p>看职业</p>
				</div>
				<div class="navli" @click="goIndex('2',4)">
					<img src="../../assets/img/n4.png" alt="" />
					<p>查批次线</p>
				</div>
				<div class="navli" @click="goIndex('2',5)">
					<img src="../../assets/img/n5.png" alt="" />
					<p>录取查询</p>
				</div>
				<div class="navli" @click="goIndex('1',6)">
					<img src="../../assets/img/n6.png" alt="" />
					<p>一分一段</p>
				</div>
				<div class="navli" @click="goIndex('2',7)">
					<img src="../../assets/img/n7.png" alt="" />
					<p>学科评估</p>
				</div>
				<div class="navli" @click="goIndex('2',8)">
					<img src="../../assets/img/n8.png" alt="" />
					<p>提前批</p>
				</div>
			</div>
			<div class="home_conavtwo">
				<div class="home_conavtwotit">专业测评</div>
				<div class="home_conavultwo">
					<div class="navlitwo" @click="goSkip(9)">
						<img src="../../assets/img/nnn1.png" alt="" />
						<p v-if="cpName.includes('MBTI')">查看小结</p>
					</div>
					<div class="navlitwo" @click="goSkip(10)">
						<img src="../../assets/img/nnn2.png" alt="" />
						<p v-if="cpName.includes('霍兰德')">查看小结</p>
					</div>
					<div class="navlitwo" @click="goSkip(11)">
						<img src="../../assets/img/nnn3.png" alt="" />
						<p v-if="cpName.includes('多元智能')">查看小结</p>
					</div>
					<div class="navlitwo" @click="goSkip(12)">
						<img src="../../assets/img/nnn4.png" alt="" />
						<p v-if="cpName.includes('学科兴趣')">查看小结</p>
					</div>
					<div class="navlitwo" @click="goSkip(13)">
						<img src="../../assets/img/nnn5.png" alt="" />
						<p v-if="cpName.includes('职业兴趣')">查看小结</p>
					</div>
					<div class="navlitwo" >
					</div>
				</div>
			</div>
			
			<div class="home_conavtwo" v-if="false">
				<div class="home_conavtwotit">推荐视频</div>
				<div class=" home_conavultwoNew">
					<div class=" navlitwoNew" v-for="(item,index) in vodeList" v-if="item.type==1" @click="courseClick(item)">
						<div class="navlitwoNewimg"><img :src="UPLODE_URL+item.courseLogo" alt="" /></div>
						<p>{{item.typeName}}</p>
					</div>
					<!-- <div class="navlitwo navlitwoNew"> 
						<img src="../../assets/img/nnn2.png" alt="" />
						<p></p>
					</div>
					<div class="navlitwo navlitwoNew">
						<img src="../../assets/img/nnn3.png" alt="" />
						<p></p>
					</div>
					<div class="navlitwo navlitwoNew">
						<img src="../../assets/img/nnn4.png" alt="" />
						<p></p>
					</div> -->
				</div>
			</div>
			
			
			<div class="home_conavtwo" v-if="false">
				<div class="home_conavtwotit">热门大学排行榜</div>
				<div class=" home_conavultwoNew">
					<div class="navlitwoNewShc" v-for="(item,index) in vodeListA">
						<div class="rowtitle">校友会大学排名</div>
						<div class="rowcen">
							<div class="rowcen-l">
								<div class="rowcen-la">1</div>
								<div class="rowcen-lb"><img src="../../assets/img/n1.png" alt="" /></div>
								<div class="rowcen-lc">
									<p class="p1">北京大学</p>
									<p class="p2"><span>北京</span><span>综合类</span></p>
								</div>
							</div>
							<div class="rowcen-r">星级：8</div>
						</div>
					</div>
					<!-- <div class="navlitwo navlitwoNew">
						<img src="../../assets/img/nnn2.png" alt="" />
						<p></p>
					</div>
					<div class="navlitwo navlitwoNew">
						<img src="../../assets/img/nnn3.png" alt="" />
						<p></p>
					</div>
					<div class="navlitwo navlitwoNew">
						<img src="../../assets/img/nnn4.png" alt="" />
						<p></p>
					</div> -->
				</div>
			</div>
			
		<!-- 录取查询 弹框 -->
		<el-dialog title="" :visible.sync="enrollOpen" width="40vw" append-to-body class="view-dialog" >
			<div class="alert">
				<div class="record" style="height: 43vh;" v-if="resuData.returnCode=='SUCCESS'">
					<div class="recordtop">
						<div class="recordtopa">恭 喜！</div>
						<div class="recordtopb">已成功查询到您的录取结果</div>
					</div>
					<div class="recordmain">
						<div class="recordmainul">
							<div class="recordmaina">院校名称:</div>
							<div class="recordmainb">{{resuData.schoolName}}</div>
						</div>
						<div class="recordmainul">
							<div class="recordmaina">院校代码:</div>
							<div class="recordmainb">{{resuData.schoolCode}}</div>
						</div>
						<div class="recordmainul">
							<div class="recordmaina">专业名称:</div>
							<div class="recordmainb">{{resuData.majorName}}</div>
						</div>
						<div class="recordmainul">
							<div class="recordmaina">专业代码:</div>
							<div class="recordmainb">{{resuData.majorCode}}</div>
						</div>
						<div class="recordmainul">
							<div class="recordmaina">投档分:</div>
							<div class="recordmainb">{{resuData.branch}}</div>
						</div>
						<div class="recordmainul">
							<div class="recordmaina">院校计划:</div>
							<div class="recordmainb">{{resuData.plan}}</div>
						</div>
						<div class="recordmainul">
							<div class="recordmaina">投递最低位次:</div>
							<div class="recordmainb">{{resuData.rank}}</div>
						</div>
						<div class="resultboot">以上结果仅供参考，实际录取结果以考试院官方结果为准</div>
					</div>
				</div>
				
				<div class="result" v-else>
				   <div class="record" style="height: 30vh;" >
						<div class="recordtop">
							<div class="recordtopa"></div>
							<div class="recordtopa">{{resuData.returnCode}}</div>
						</div>
				  <!-- <div class="resultboot">以上结果仅供参考，实际录取结果以考试院官方结果为准</div> -->
					</div>
				</div>
			</div>	
			
		</el-dialog>
		
		


		

		

	</div>
</template>

<script>
	// import Swiper from "swiper";
	// import "swiper/css/swiper.min.css
	// import  {group} from '@/utils/fenlei'
	import  {UPLODE_URL} from '@/utils/request'
	import BaiduMap from "@/view/home/component/map.vue";
	import { EventBus } from '@/utils/event-bus.js';
	import {
		
		lunbotu,
		jituanjianjie,
		shipinshouye,
		ywtx,
		ssfw,
		jjrongyu,
		qxpp,
		homeimage
	} from "@/api/home";
	export default {
		components: {
			BaiduMap,
		},

		data() {
			return {
				UPLODE_URL,
				pushFlag: localStorage.getItem('pushFlag')||'',
				enrollOpen:false,//录取查询 弹框
				resuData:{
				  returnCode:'',//  除了 SUCCESS 都是错误返回
				  schoolCode:'',// 录取学校代码
				  schoolName:'',// 名称
				  majorCode:'',// 专业代码
				  majorName:'',// 专有名称
				  branch :'',//分数
				  plan:'',//  投档数
				  rank:'',// 投递最低位次
				},//录取结果
				
				
				bannerData:[],//轮播
				token: localStorage.getItem('token')||'',
				user:JSON.parse(localStorage.getItem('user'))||'',
				
				// 志愿数量
				volNumData:{
					jihuaNum:'',
					jihuaNumBack:'',
					score:'',//综合分
					subjectOne:'',//选科
					scorePtn:'',//位次
					cityIdName:'',
					batchIdName:'',
					countOne:'',
					countTwo:'',
					countThree:''
				},
				
				lunbotu: null,
				jituanjianjie: {},
				shipin: "",
				yewutixi: {},
				fourSerData: {},
				rongyu: {},
				rongyu_list: [],
				qixia: {},
				qixiapinpai: [],
				intro: "",
				homeimg: '',
				cpName:[],//已经测评的name
				
				vodeList:[{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）",courseUrl:"集合的概念.mp4"},{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）",courseUrl:"集合的概念.mp4"},{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）"},{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）"},{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）"}],
				vodeListA:[{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）",courseUrl:"集合的概念.mp4"},{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）",courseUrl:"集合的概念.mp4"},{courseBanner: "17346770996131324.jpg",courseName:"集合的概念（高一）"}]
			};
		},
		created() {
			// this.homeBanner();
			EventBus.$on('tui', () => {
			    this.token = localStorage.getItem('token')||''
			    this.user=JSON.parse(localStorage.getItem('user'))||''
				console.log('asdasdasdasdas111',this.token)
				console.log('asdasdasdasdas222',this.user)
			});
			
			// 监听退出登录事件
			    EventBus.$on('logout', this.handleLogout);
		},
		beforeDestroy() {
		    EventBus.$off('tui');
			EventBus.$off('showModal')
			EventBus.$off('vipOpen')
			EventBus.$off('noopsycheOpen')
			EventBus.$off('open')
			
			window.removeEventListener('storage', this.handleStorageEvent);
		},
		mounted() {
			this.homeBanner();
			EventBus.$on('tui', () => {
			    this.token = localStorage.getItem('token')||''
			    this.user=JSON.parse(localStorage.getItem('user'))||''
				console.log('asdasdasdasdas111',this.token)
				console.log('asdasdasdasdas222',this.user)
				this.adminTi()//是否测评过
				if(this.user.culture){
					this.getUSerInfo()
					this.getOTS()//冲保稳
				}

			});
			// let that = this
			// that.setProgress(0);
			// setTimeout(() => {
			//   that.setProgress(100);
			// }, 1000); // 过渡时间为1秒，你可以根据需要调整这个值
			// 登录完 确定完 去请求录取接口
			EventBus.$on("callLoginDialog", () => {
				this.token=localStorage.getItem('token')||''
				this.user=JSON.parse(localStorage.getItem('user'))||''
				this.adminTi()//是否测评过
				// this.getOTS()//冲保稳
				if(this.user.culture){
					this.getOTS()//冲保稳
					
				}

			});
			
			if(this.user){
				this.adminTi()//是否测评过
				this.getOTS()//冲保稳
				if(this.user.culture){
					this.getUSerInfo()
				}

			}
			// this.viodGet()//推荐视频
			window.addEventListener('storage', this.handleStorageEvent);
		},
		methods: {
			// 和小程序同步信息
			getUSerInfo(){
				
				this.api.appMyInfoApi().then(res => {
					if(res.code==200){
						console.log('res信息',res.data)
						localStorage.setItem("user", JSON.stringify(res.data));
						this.user=res.data||''
					}else{
						this.$message.error(res.data.msg);
					}
				})
			},

			handleStorageEvent(event) {
			      if (event.key == 'token') {
			        // 更新登录状态
						this.token=localStorage.getItem('token')||''
						this.user=JSON.parse(localStorage.getItem('user'))||''
						this.$router.push({path:'/'})
						window.location.reload()
			        // this.checkLoginStatus();
			      }
			    },
			handleLogout(){
				console.log('触发了联动清除缓存')
				localStorage.removeItem('user');
				localStorage.removeItem('cardType');
				localStorage.removeItem('token');
				localStorage.removeItem('pushId');
				localStorage.removeItem('xiaoid');
				this.user = {}
				this.token =''
				// EventBus.$emit('tui');
				// EventBus.$emit('logout');
				this.$router.push({path:'/'})
			},
			// 推荐视频 跳转列
			courseClick(item){
				console.log('this.token',this.token)
				if(!this.token) {
					EventBus.$emit('noopsycheOpen');
				}else if(!this.user.score){
					EventBus.$emit('showModal');
					return
				}else{
					this.$router.push({path:'/Ainformation/video',query:{id:item.id,name:item.typeName}})
				}
				
				
				// if(!uni.getStorageSync('token')) {
				// 	uni.navigateTo({
				// 		url: '/pages/login/login'
				// 	});
				// }else if(!this.user.score){
				// 	uni.navigateTo({
				// 		url: '/pages/examination/examination?my=1'
				// 	});
				// 	return
				// }else{
				// 	uni.navigateTo({
				// 		url:`/pages/index/courseInfoVideo?id=${item.id}&name=${item.typeName}&pushFlag=${this.pushFlag}&userVip=${this.user.userVip}`
				// 	})
				// }
			},
			// 推荐视频
			viodGet(){
				let qu = {
					pushFlag:this.pushFlag
				}
				this.api.courseTypeListApi(qu).then(res => {
					if (res.code==200) {
						this.vodeList  = res.data
					}
				})
			},
			// 冲保稳
			getOTS(){
				this.api.appJihuaNumApi().then(res => {
					if (res.code==200) {
						this.volNumData.countOne = res.data.countOne
						this.volNumData.countTwo = res.data.countTwo
						this.volNumData.countThree = res.data.countThree
					}
				})
			},
			
			// 是否测评过
			adminTi(){
				let qu={
					type:1,
					userId:this.user.id,
				}
				this.api.adminTiGetQuISCode(qu).then(res => {
					console.log('res',res)
				  if (res.code==200) {
				    let d = res.data
				    for(let i in d){
				    	if(i==1&&d[1]==2){
				    		this.cpName.push('霍兰德')
				    	}
				    	if(i==2&&d[2]==2){
				    		this.cpName.push('MBTI')
				    	}
				    	if(i==3&&d[3]==2){
				    		this.cpName.push('多元智能')
				    	}
				    	if(i==4&&d[4]==2){
				    		this.cpName.push('学科兴趣')
				    	}
						if(i==5&&d[5]==2){
							this.cpName.push('职业兴趣')
						}
				    }
				  } else {
				    this.$message.error(res.message);
				  }
				})
			},
			// 首页banner
			homeBanner(){
				
				this.bannerData = [{bannerImage: "17370983455851445.jpg"}]
				return
				
				console.log('22222')
				let params = {
					
				}
				this.api.GetHomeBanner(params).then(res => {
					console.log('res',res)
				  if (res.code==200) {
				    this.bannerData = res.data
				  } else {
				    this.$message.error(res.message);
				  }
				})
			},
			allUserClick(){
				this.getUSerInfo()
				this.getOTS()
				 EventBus.$emit('showModal');
			},
			
			//测评
			goSkip(){
				if(!this.token) {
					EventBus.$emit('noopsycheOpen');
				}else if(!this.user.score){
					EventBus.$emit('showModal');
					return
				}else{
					let URL=`https://el.baizebang.com?id=${this.user.id}`
					window.open(URL, '_blank');
				}
			},
			
			goIndex(type,i){
				if(this.token&&this.user.culture){
					this.getUSerInfo()
					this.getOTS()
				}
				

				if(type==1){
					if(i==1){
						// 查学校
						this.$router.push({path:'/Ainformation/school'})
					}
					
					if(i==2){
						// 查专业
						this.$router.push({path:'/Ainformation/major'})
					}
					
					if(i==3){
						// 看职业
						this.$router.push({path:'/Ainformation/occupation'})
					}
					
					if(i==6){
						// 一分一段
						this.$router.push({path:'/Ainformation/subsection'})
					}
				}else{
					
					if(!this.token) {
						EventBus.$emit('noopsycheOpen');
					}else if(!this.user.score){
						EventBus.$emit('showModal');
						return
					}else{
						if(i==4){
							// 查批次线
							this.$router.push({path:'/Ainformation/batchBorder'})
						}
						if(i==5){
							// 录取查询
							// this.$router.push({path:'/Ainformation/batchBorder'})
							
							
							this.api.appUserRecodInfoApi().then(res => {
								console.log('res',res)
								if (res.code==200) {
									if(res.data.returnCode=='SUCCESS'){
									  this.resuData = res.data;
									  this.enrollOpen = true;
									}else{
									   this.$message.error(res.data.returnCode);
									}
								}else{
									
									this.$message.error(res.msg);
								}
							
							})
							//
								
							
							
						}
						
						if(i==7){
							// 学科评估
							this.$router.push({path:'/Ainformation/shamSchool'})
						}
						if(i==8){
							// 提前批
							this.$router.push({path:'/Ainformation/advance'})
						}
						if(i==9){
							// 提前批
							this.$router.push({path:'/AAIvol/vol'})
						}
						
					}
				}
				
			},
			
			// setProgress(percentage) {
			//   const circleProgress = document.querySelector('.circle-progress');
			// const circleBackground = document.querySelector('.circle-background');
			//   const percentageText = document.getElementById('percentage');
			 
			//   const circumference = 2 * Math.PI * 40; // 圆的周长
			// const circumNewLength = (percentage / 100) * (circumference - 52);
			//   const dashOffset = 163 - circumNewLength;
			 
			 
			//   // 设置进度圆环的样式
			//   circleBackground.style.strokeDashoffset = dashOffset;
			// circleBackground.style.strokeDasharray = `${300 - circumNewLength}, ${ 52 + circumNewLength }`
			// circleProgress.style.strokeDasharray = `${circumNewLength}, ${ circumference - circumNewLength }`
			  
			//   // 更新百分比文本
			//   // percentageText.textContent = `${percentage}%`;
			// },
			
			
			// 分组方法三个参数分别是 新数组，原数组，几个分为一组
			group(newArr, arr, num) {
				if (arr.length > 0) {
					if (arr.length > num) {
						//arr 的长度大于 分组数
						newArr.push(arr.splice(0, num)); //分组
						this.group(newArr, arr, num); //递归
					} else {
						//如果长度不够分为一组，就直接把剩余的分为一组
						newArr.push(arr.splice(0, arr.length));
					}
				}
				return newArr; //返回已分组的新数组
			},
			ljqingkao() {
				this.$router.push("/Ainormation/introduce");
			},
			// 业务体系
			ywtixi(id) {
				
			},
			// 四师服务
			fourSer() {
				this.$router.push("/XMFU/fourSer");
			},
			// 荣誉
			rongyuzz() {
				this.$router.push("/Ainormation/honor");
			},
			chen() {
				// console.log(1);
			},
			// chengren() {
			//   this.$router.push("/Chengkao");
			// },
			// shenbao() {
			//   this.$router.push("/shenbao");
			// },
			// guokai() {
			//   this.$router.push("/Guojiakaifang");
			// },
		},
	};
</script>

<style lang="scss" scoped>
	
	
	
	
	
	
	
	
	
	
	
	
	
	.el-carousel__item.is-animating {

		transition: opacity .2s ease-in-out !important;
	}

	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.home_box {

		// height: 2000px;
		// 顶部轮播图
		.home_top_swiper {
			width: 100%;
			height: 440px;
			position: relative;

			// background-color: #9b0e12;
			// width: 440px;
			// swiper左右按钮
			/deep/ .el-car {
				width: 100%;
				height: 100%;
			}

			img {
				width: 100%;
				height: 440px;
				object-fit: cover;
			}

			// /deep/.el-carousel__item{
			// height: 100%;
			// }
			/deep/.el-carousel__arrow {
				// background-color: #30384d;
				width: 70px;
				height: 70px;
				// border-radius: 0px;
			}

			// 左右按钮图标
			/deep/.el-icon-arrow-left {
				font-size: 40px;
			}

			/deep/.el-icon-arrow-right {
				font-size: 40px;
			}



			// 志愿模拟填报
			.uservol {
				position: absolute;
				cursor: pointer;
				top: 40px;
				right: 16%;
				z-index: 100;
				width: 300px;
				height: 300px;
				background-color: #fff;
				border-radius: 6px;
				padding: 30px;
				.ustit-a{
					font-size: 26px;
					font-weight: bold;
				}
				.ustit-b{
					font-size: 14px;
					color: #646464;
					font-weight: bold;
					margin-bottom: 20px;
					margin-top: 5px;
				}
				.ustit-c{
					width: 224px;
					height: 112px;
					background: url(../../assets/img/hu.png) no-repeat;
					background-size: 100% 100%;
					text-align: center;
					margin: 5px auto 10px;
					position: relative;
					.ustit-cmain{
						padding-top: 60px;
					}
					.ustit-czu{
						// position: absolute;
						// bottom: 0;
						font-size: 30px;
						font-weight: bold;
						line-height: 20px;
						span{
							font-size: 14px;
						}
					}
				}
			
				.ustit-d{
					width: 90%;
					margin: 0 auto;
					display: flex;
					.ustit-dli{
						flex: 1;
						align-items: center;
						font-size: 16px;
						display: flex;
						justify-content: center;
						span{
							font-size: 12px;
							margin-right: 4px;
							// margin-left: 14px;
							position: relative;
							padding-left: 14px;
						}
					}
					.ustit-dli:nth-child(1) span:before{
						content: '';
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background: #F34341;
						position: absolute;
						left: 0;top: 4px;
					}
					.ustit-dli:nth-child(2) span:before{
						content: '';
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background: #21CD7E;
						position: absolute;
						left: 0;top: 4px;
					}
					
					.ustit-dli:nth-child(3) span:before{
						content: '';
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background: #FA8E23;
						position: absolute;
						left: 0;top: 4px;
					}
					
				}
				.ustit-btn{
					width: 90%;
					margin: 20px auto 0;
					height: 50px;
					border-radius: 6px;
					background-color:#F34240;
					color: #fff;
					font-size: 17px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}


		}

		//  学习点燃新希望总体
		.home_hope {
			width: 100%;
			text-align: center;
			box-sizing: border-box;
			padding-top: 100px;
			margin-bottom: 100px;

			// 学习点燃新希望标签
			.home_hope_titleH1 {
				font-size: 40px;
				color: #30384d;
				font-weight: 600;
				margin-bottom: 20px;
			}

			// 成为教育行业的领跑者
			.home_hope_titleH2 {
				font-size: 32px;
				color: #2f384a;
				margin-bottom: 50px;
			}

			// 介绍小字外面包裹的大盒子
			.home_hope_div {
				width: 1350px;
				line-height: 36px;
				font-size: 18px;
				margin: 0 auto;
				margin-top: 50px;

				// display: flex;
				// flex-direction: column;
				// justify-content: center;
				// align-content: center;
				// 介绍的所有的字
				.home_hope_jieshao {
					margin: 0 auto;
					width: 980px;
					color: #2f384a;
				}

				// 了解详情
				.home_hope_xiangqing {
					font-size: 15px;
					color: #9b0e12;
					margin-top: 50px;
					margin-bottom: 85px;
				}

				.home_hope_xiangqing:hover {
					color: red;
				}
			}

			.home_hope_ul {
				width: 1350px;
				display: flex;
				margin: 0 auto;

				li {
					flex: 1;

					// 年龄介绍
					.home_hope_ul_old {
						font-size: 60px;
						font-weight: 600;
						color: #9b0e12;
					}

					// 介绍行业
					.home_hope_ul_text {
						font-size: 20px;
					}
				}
			}

			.home_hope_pic {
				margin: 0 auto;
				// height: 750px;
				width: 1400px;

				img {
					width: 100%;
					height: 100%;
				}

				// height: 200px;
				// background-color: red;
			}
		}

		// 首页视频
		.home_video {
			display: flex;
			width: 1400px;
			height: 515px;
			margin: 0 auto;

			.home_video_left {
				width: 875px;
				object-fit: fill;
			}

			.home_video_right {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 530px;
				// height: 515px;
				font-size: 16px;
				// background-image: url("../../assets/视频背景图.png");
				background-color: #9b0e12;

				img {
					width: 90%;
					height: 90%;
					object-fit: cover;
				}

				// 右侧文字介绍
				// .home_video_right_div {
				//   margin-top: -30px;
				//   width: 500px;
				//   // height: 100px;
				//   margin-left: 50px;
				//   position: relative;
				//   color: #fff;
				//   .home_video_right_img {
				//     height: 37px
				//   }
				//   // 互动授课
				//   .home_video_right_span {
				//     position: absolute;
				//     top: 8px;
				//     left: 50px;
				//     font-weight: 600;
				//     // font-size: 18px;
				//   }
				//   .home_video_right_div_div1 {
				//     position: absolute;
				//     top: 45px;
				//     left: 50px;
				//     width: 300px;
				//     // font-size: 15px;
				//   }
				//   // .home_video_right_div_div2 {
				//   //   position: absolute;
				//   //   top: 75px;
				//   //   left: 50px;
				//   // }
				// }
			}
		}

		// 轮播图 四大业务体系
		.home_box_sidayewutixi {

			// swiper左右按钮
			/deep/.el-carousel__arrow {
				background-color: #30384d;
				width: 60px;
				height: 60px;
				border-radius: 0px;
			}

			// 左右按钮图标
			/deep/.el-icon-arrow-left {
				font-size: 32px;
			}

			/deep/.el-icon-arrow-right {
				font-size: 32px;
			}

			height: 500px;
			width: 1400px;
			margin: 0 auto;
			margin-top: 100px;

			.home_box_sidayewutixi_h1 {
				font-size: 40px;
				font-weight: 800;
				color: #30384d;
				margin-bottom: 80px;
				text-align: center;
			}

			.home_box_sidayewutixi_h1_divbox {
				height: 580px;
				width: 1400px;

				/deep/ .el-car {
					height: 530px;
					width: 100%;
				}
			}

			.swiper_box {
				width: 1200px;
				height: 100%;
				margin: 0 auto;
				display: flex;

				//轮播图左侧图片
				.swiper_box_left {
					width: 65%;
					height: 100%;
					background-color: red;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}

				// 轮播图 右侧文字介绍
				.swiper_box_right {
					height: 100%;
					padding-left: 50px;
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: space-evenly;

					//学历教育
					.swiper_box_right_h1 {
						color: #30384d;
						font-size: 30px;
						font-weight: 600;
					}

					// 学历教育介绍
					.swiper_box_right_div {
						text-indent: 2em;
						font-size: 17px;
						line-height: 30px;
						// margin-top: 40px;
						// margin-bottom: 10px;
					}

					// 了解更多按钮
					.swiper_box_right_buttom {
						width: 160px;
						height: 40px;
						color: #fff;
						font-size: 15px;
						background-color: #9b0e12;
						text-align: center;
						line-height: 40px;
					}

					.swiper_box_right_buttom:hover {
						opacity: 0.6;
					}

					.swiper_box_right_buttom:active {
						opacity: 0.8;
					}
				}
			}
		}

		// 四师服务体系
		.home_ssfwtx {
			width: 1400px;
			height: 500px;
			margin: 0 auto;
			margin-top: 250px;
			margin-bottom: 80px;

			// 标签
			.home_ssfwtx_h1 {
				text-align: center;
				font-size: 40px;
				font-weight: 600;
				color: #30384d;
				margin-bottom: 75px;
			}

			.home_ssfwtx_div {
				width: 100%;
				height: 380px;

				.home_ssfwtx_ul {
					display: flex;
					height: 380px;

					li {
						// width: 340px;
						// flex: 1;
						width: 23%;
						margin: 0 8px;
						height: 100%;

						.home_ssfwtx_ul_img {
							height: 230px;
							width: 100%;
							background-color: #9b0e12;

							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.home_ssfwtx_box {
							width: 285px;
							height: 120px;
							padding-left: 15px;

							.home_ssfwtx_ul_h1 {
								text-align: center;
								color: #30384d;
								font-size: 18px;
								font-weight: 600;
								margin-top: 15px;
								margin-bottom: 15px;
							}

							.home_ssfwtx_ul_div {
								text-indent: 2em;
								// text-align: center;
								margin: 0 auto;
								font-size: 14px;
								color: #30384d;
							}
						}
					}
				}
			}
		}

		// 荣誉资质
		.home_rongyu {
			/deep/ .el-car {
				height: 100%;
				width: 100%;
			}

			// swiper左右按钮
			/deep/.el-carousel__arrow {
				background-color: #30384d;
				width: 60px;
				height: 60px;
				border-radius: 0px;
			}

			// 左右按钮图标
			/deep/.el-icon-arrow-left {
				font-size: 32px;
			}

			/deep/.el-icon-arrow-right {
				font-size: 32px;
			}

			width: 100%;
			height: 900px;
			display: flex;
			justify-content: space-evenly;
			align-content: center;
			flex-direction: column;
			background-color: #9b0e12;
			box-sizing: border-box;

			.home_rongyu_h1 {
				text-align: center;
				font-size: 40px;
				font-weight: 600;
				color: #fff;
			}

			.home_rongyu_swiper {
				width: 1450px;
				height: 600px;
				// height: fit-content;
				// background-color: blue;
				margin: 0 auto;

				.home_rongyu_swiper_div {
					width: 1240px;
					// height: 690px;
					margin: 0 auto;

					.home_rongyu_swiper_ul {
						height: 100%;
						display: flex;
						flex-wrap: wrap;
						justify-content: space-between;

						li {
							background-color: #fff;
							width: 400px;
							display: flex;
							justify-content: center;
							align-items: center;

							// padding: 20px;
							// height: 340px;
							&:nth-child(-n + 3) {
								margin-bottom: 20px;
							}

							.home_rongyu_swiper_ul_div {
								flex: 1;
								margin: 15px;
								background-color: #9b0e12;
							}

							.home_rongyu_swiper_ul_title {
								color: #30384d;
								font-size: 18px;
								font-weight: 600;
								margin-top: 25px;
								text-align: center;
							}
						}
					}
				}
			}

			// 了解更多按钮
			.swiper_box_right_buttom {
				width: 160px;
				height: 40px;
				color: #9b0e12;
				font-size: 15px;
				background-color: #fff;
				text-align: center;
				line-height: 40px;
				margin: 0 auto;
				// margin-top: 50px;
			}

			.swiper_box_right_buttom:hover {
				opacity: 0.9;
			}

			.swiper_box_right_buttom:active {
				opacity: 0.8;
			}
		}

		// 校区分布
		.home_school {
			width: 100%;
			height: 470px;
			margin-top: 50px;

			.home_school_box {
				width: 1400px;
				height: 470px;
				margin: 0 auto;

				.home_school_h1 {
					text-align: center;
					font-size: 40px;
					font-weight: 600;
					color: #30384d;
					margin-bottom: 50px;
				}
			}
		}

		// 轮播图 旗下品牌
		.home_box_qixiapinpai {
			height: 450px;
			width: 1400px;
			margin: 0 auto;
			margin-top: 100px;

			// swiper左右按钮
			/deep/ .el-car {
				width: 100%;
				height: 100%;
			}

			/deep/.el-carousel__arrow {
				background-color: #30384d;
				width: 60px;
				height: 60px;
				border-radius: 0px;
			}

			// 左右按钮图标
			/deep/.el-icon-arrow-left {
				font-size: 32px;
			}

			/deep/.el-icon-arrow-right {
				font-size: 32px;
			}

			.home_box_home_box_qixiapinpai_h1 {
				font-size: 40px;
				font-weight: 800;
				color: #30384d;
				margin-bottom: 50px;
				text-align: center;
			}

			.qixiapinpai_box {
				width: 1230px;
				height: 325px;
				margin: 0 auto;
				display: flex;

				.qixiapinpai_ul {
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: space-around;

					li {
						width: 392px;
						height: 100%;
						background-color: #fff;
						border: 1px solid #9aa7d0;

						.qixiapinpai_li_div {
							height: 234px;
							width: 100%;
							background-color: #9b0e12;
						}

						.qixiapinpai_li_title {
							color: #30384d;
							font-size: 18px;
							font-weight: 600;
							margin-top: 25px;
							text-align: center;
						}
					}
				}
			}
		}

		// .home_box_kaoshi {
		//   // margin-top: 20px;
		//   width: 1300px;
		//   // height: 300px;
		//   // background-color: blue;
		//   margin: 0 auto;
		//   // background-color: red;
		//   display: flex;
		//   justify-content: space-around;
		//   img {
		//     width: 400px;
		//     // height: 80px;
		//     border-radius: 10px;
		//     object-fit: cover;
		//   }
		// }
	}
	
	
	// 查数据
	.home_conav	{
		// width: 74%;
		width: 1300px;
		background: #fff;
		padding-top: 30px;
		margin: 30px auto;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-webkit-justify-content: space-between;
		-ms-flex-pack: justify;
		flex-wrap: wrap;
		justify-content: center;
		text-align: center;
		border-radius: 6px;
		.navli{
			width: 25%;
			margin-bottom: 30px;
			p{
				margin-top: 20px;
				font-size: 20px;
			}
			img{
				width: 100px;
				height: 100px;
				cursor: pointer;
			}
		}
		
		
		// .navli:hover{
		//   // background: #ccc;
		//   box-shadow: 0px 2px 6px 0px #E4E4E4;
		// }
	}
	
	
	.home_conavtwo{
		width: 1300px;
		margin: 30px auto;
		.home_conavtwotit{
			font-size: 32px;
			font-weight: bold;
		}
		.home_conavultwo{
			padding-top: 20px;
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-pack: justify;
			-webkit-justify-content: space-between;
			-ms-flex-pack: justify;
			flex-wrap: wrap;
			justify-content: center;
			text-align: center;
			.navlitwo{
				width: 49%;
				position: relative;
				margin-bottom: 20px;
				img{
					width: 100%;
				}
				// img:hover{
				//   // background: #ccc;
				//   box-shadow: 0px 2px 6px 0px #E4E4E4;
				// }
				p{
					position: absolute;
					    /* bottom: 20px; */
					    left: 29%;
					    top: 20%;
					    /* width: 200px; */
					    height: 50;
					    font-size: 18px;
				}
			}
			.navlitwo:nth-child(1) {
				margin-right: 20px;
			}
			.navlitwo:nth-child(3) {
				margin-right: 20px;
			}
		}
		
		.home_conavultwoNew{
			padding-top: 20px;
			// display: -webkit-box;
			// display: -webkit-flex;
			// display: -ms-flexbox;
			display: flex;
			// -webkit-box-pack: justify;
			// -webkit-justify-content: space-between;
			// -ms-flex-pack: justify;
			flex-wrap: wrap;
			    // justify-content: flex-start !important;
				.navlitwoNew:hover{
					box-shadow: 3px 5px 15px rgba(204, 204, 204, 0.55);
				}
			.navlitwoNew{
				width: 23.7%!important;
				background-color: #fff;
				border-radius: 10px;
				-webkit-box-pack: justify;
				-webkit-justify-content: space-between;
				-ms-flex-pack: justify;
				flex-wrap: wrap;
				justify-content: center;
				margin-top: 0 !important;
				border-radius: 8px;
				background: white;
				box-shadow: 3px 5px 15px rgba(204, 204, 204, 0.25);
				padding: 15px 20rpx;
				justify-content: flex-start !important;
				overflow: hidden;
				margin-bottom: 20px;
				margin-right: 20px;
				cursor: pointer;
				.navlitwoNewimg{
					width: 140px;
					height: 120px;
					margin: 10px auto;
					img{
						object-fit: fill;
						width: 100%;
						height: 100%;
					}
				}
				
				p{
					height: 50px;
					font-size: 20px;
					text-align: left;
					display: flex;
					/* padding-left: 20px; */
					/* padding-top: 20px; */
					display: flex;
					justify-content: center;
				}
			}
		
			// 热门大学排行榜
			.navlitwoNewShc{
				width: 380px!important;
				margin-right: 20px;
				background: linear-gradient(180deg, #FCD6D3 0%, #fff 100%);
				border-radius: 10px;
				padding: 30px 20px;
				.rowtitle{
					font-size: 22px;
					color: #000;
					font-weight: bold;
					margin-bottom: 30px;
				}
				.rowcen{
					display: -webkit-box;
					display: -webkit-flex;
					display: -ms-flexbox;
					display: flex;
					-webkit-box-pack: justify;
					-webkit-justify-content: space-between;
					-ms-flex-pack: justify;
					align-items: center;
					.rowcen-l{
						display: flex;
						align-items: center;
						.rowcen-la{
							font-size: 14px;
							font-weight: bold;
							margin-right: 10px;
						}
						.rowcen-lb{
							img{
								width: 50px;
								height: 50px;
								border-radius: 50%;
							}
							margin-right: 10px;
						}
						.rowcen-lc{
							.p1{
								font-size: 17px;
							}
							.p2{
								font-size: 12px;
								display: flex;
								span{
									margin-right: 10px;
								}
							}
						}
					}
				}
			}
			.navlitwoNewShc:nth-child(3){
				margin-right: 0px;
			}
			.navlitwoNew:nth-child(4) {
				margin-right: 0px;
			}
			.navlitwoNew:nth-child(8) {
				margin-right: 0px;
			}
			.navlitwoNew:nth-child(12) {
				margin-right: 0px;
			}
		}
		
		
	}
	
	
	
	
	.view-dialog /deep/.el-dialog {
	  border-radius: 10px!important;
	  // background: linear-gradient(180deg, rgba(0.999,0.402,0.009,1) 0%, rgba(255,255,255, 1) 100%);
	  
	  // background: linear-gradient(0deg, #FE7443 0%, rgba(255,255,255, 1) 50%);
	}
	
.record{
	margin:0 15px 15px 15px;
	.recordtop{
		text-align: center;
		.recordtopa{
			font-size: 30px;
			color:#F24041;
		}
		.recordtopb{
			font-size: 18px;
			color:#F24041
		}
	}
	.recordmain{
		margin-top: 20px;
		.recordmainul{
			display: flex;
			// align-items: center;
			margin-bottom: 10px;
			.recordmaina{
				width:100px;
				margin-right: 15px;
				font-size: 14px;
				white-space:nowrap;
				color:#000;
			}
			.recordmainb{
				flex:1;
				color: #333;
				font-size: 13px;
			}
		}
		.resultboot{
			font-size: 12px;
			color: #333;
			text-align: center;
			position: absolute;bottom: 20px;
			left: 0;
			right: 0;
			margin: auto;
		}
	}
}
	.session{
		position: fixed;
		z-index: 999;
		right: 10px;
		bottom: 16vh;
		img{
			width: 57px;
			height: 66px;
			// box-shadow: 0px 2px 4px  #151515;
		}
	}	
</style>